var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_4603",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_4603)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9992 44.8C21.1446 44.8 18.4449 44.258 15.9002 43.174C13.3556 42.09 11.1446 40.6093 9.26722 38.732C7.38989 36.8547 5.90922 34.6437 4.82522 32.099C3.74122 29.5543 3.19922 26.8547 3.19922 24C3.19922 21.1453 3.74122 18.4457 4.82522 15.901C5.90922 13.3563 7.38989 11.1453 9.26722 9.268C11.1446 7.39066 13.3556 5.91 15.9002 4.826C18.4449 3.742 21.1446 3.2 23.9992 3.2C26.8539 3.2 29.5536 3.742 32.0982 4.826C34.6429 5.91 36.8539 7.39066 38.7312 9.268C40.6086 11.1453 42.0892 13.3563 43.1732 15.901C44.2572 18.4457 44.7992 21.1453 44.7992 24C44.7992 26.8547 44.2572 29.5543 43.1732 32.099C42.0892 34.6437 40.6086 36.8547 38.7312 38.732C36.8539 40.6093 34.6429 42.09 32.0982 43.174C29.5536 44.258 26.8539 44.8 23.9992 44.8ZM23.9992 41.15C25.9996 41.15 27.9247 40.825 29.7747 40.175C31.6244 39.525 33.2992 38.5667 34.7992 37.3L10.6992 13.2C9.46589 14.7333 8.51589 16.4195 7.84922 18.2585C7.18255 20.0975 6.84922 22.0113 6.84922 24C6.84922 28.779 8.51272 32.8322 11.8397 36.1595C15.1671 39.4865 19.2202 41.15 23.9992 41.15ZM37.2492 34.8C38.4159 33.3 39.3576 31.6252 40.0742 29.7755C40.7909 27.9255 41.1492 26.0003 41.1492 24C41.1492 19.2207 39.4857 15.1675 36.1587 11.8405C32.8317 8.5135 28.7786 6.85 23.9992 6.85C22.0106 6.85 20.0967 7.18333 18.2577 7.85C16.4187 8.51666 14.7326 9.48333 13.1992 10.75L37.2492 34.8Z",
    fill: "#FF0505"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.bac28189dbe0ba935020d7c21f157328.svg";
export { ForwardRef as ReactComponent };